import EDIT_ICON from "../../../../assets/svgs/edit.svg";
import HistoryDetailDisplay from "./HistoryDetailDisplay";
import HistoryDetailEdit from "./HistoryDetailEdit";
import useHistoryDetail from "../../hooks/useHistoryDetail";

const HistoryDetail = ({ subModalMount, closeModal, closeSubModal, item, date }) => {

  const {
    deviceType,
    containerRef,
    isEditing,
    formData,
    toggleEditModeHandler,
    handleLoadDesign,
    handleInputChange,
    handleUpdateHistory,
    handleDeleteHistory

  } = useHistoryDetail(item);

  const modalProps = { closeModal, closeSubModal, subModalMount };
  const editModeProps = { item, toggleEditModeHandler, formData, handleInputChange, handleUpdateHistory };
  const displayModeProps = { item, toggleEditModeHandler, formData, handleLoadDesign, handleDeleteHistory, date}

  return (
    <div className={"detail-design-history"} ref={containerRef}>
        <div className={"detail-design-history-header"}>
          <div className={"detail-design-history-inner"}>
            <span>My Design History</span>
            {
              (deviceType !== "mobile" && !isEditing) && (
                <button onClick={toggleEditModeHandler} className={"edit-button"}>
                  <img src={EDIT_ICON}/>
                </button>
              )
            }
            <button type="button" className="modal-close" onClick={closeModal}/>
          </div>
        </div>
      {
        isEditing
          ? <HistoryDetailEdit {...modalProps} {...editModeProps}/>
          : <HistoryDetailDisplay {...modalProps} {...displayModeProps} />
      }

    </div>
  )
}

export default HistoryDetail;
